/* ------------------------------------------------------------
   Frequently-Bought-Together – multi-instance safe
------------------------------------------------------------ */

/* Currency formatter
------------------------------------------------------------ */
const moneyFmt = (cents) => {
  if (window.Shopify?.formatMoney) {
    return Shopify.formatMoney(cents, "");
  }
  return (cents / 100).toLocaleString(
    "en-US",
    { style: "currency", currency: "USD" }
  );
};

/* Boot-strap all widgets on DOM ready
------------------------------------------------------------ */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".fbt-widget").forEach(initFbt);
});

/* Initialise a single widget
------------------------------------------------------------ */
function initFbt(widget) {
  const totalEl = widget.querySelector(".fbt-total");
  const addBtn  = widget.querySelector(".fbt-add");
  if (!totalEl || !addBtn) return;                 // malformed markup

  /* ----- CART-DRAWER SETTINGS --------------------------------- */
  const OPEN_IN_DRAWER = true;   // flip to false if you ever want a hard redirect
  
  /* helpers ---------------------------------------------------------------- */
  const drawerAnchor = document.querySelector(".js-drawer-open-cart");
  const hasDrawerDOM = document.querySelector("#CartDrawer,[data-location='cart-drawer']");
  
  function openCartDrawer() {
    if (!hasDrawerDOM) return false;                        // no drawer markup
  
    /* Impulse 7.x and newer */
    if (window.theme?.CartDrawer?.open) {
      window.theme.CartDrawer.open();
  
    /* some older forks keep it on Shopify.theme */
    } else if (window.Shopify?.theme?.CartDrawer?.open) {
      Shopify.theme.CartDrawer.open();
  
    /* built-in anchor fallback */
    } else if (drawerAnchor) {
      drawerAnchor.dispatchEvent(
        new MouseEvent("click", { bubbles: true, cancelable: true })
      );
    } else {
      return false;                                         // nothing worked
    }
    return true;
  }

  /* ---------- helpers ------------------------------------ */
  const updateRowPrice = (sel) => {
    const opt  = sel.selectedOptions[0];
    const row  = sel.closest(".fbt-item");
    const box  = row.querySelector(".fbt-price");

    let html = moneyFmt(+opt.dataset.price);
    if (opt.dataset.compare && +opt.dataset.compare > +opt.dataset.price) {
      html += ` <span class="compare">${moneyFmt(+opt.dataset.compare)}</span>`;
    }
    box.innerHTML = html;
  };

  const recalcTotal = () => {
    let price = 0, compare = 0;
    widget.querySelectorAll(".fbt-item").forEach((row) => {
      if (!row.querySelector(".fbt-check").checked) return;
      const opt = row.querySelector(".fbt-select").selectedOptions[0];
      const p = +opt.dataset.price;
      const c = +opt.dataset.compare;
  
      price   += p;
      /* if a product has no compare price (c==0) use p instead,
         otherwise use the real compare price */
      compare += c > 0 ? c : p;
    });
    totalEl.innerHTML =
      moneyFmt(price) +
      (compare > price ? ` <span class="compare">${moneyFmt(compare)}</span>` : "");
  };

  /* ---------- initial state ------------------------------ */
  widget.querySelectorAll(".fbt-select").forEach(updateRowPrice);
  recalcTotal();

  /* ---------- listeners ---------------------------------- */
  widget.addEventListener("change", (e) => {
    if (e.target.matches(".fbt-select")) updateRowPrice(e.target);
    if (e.target.matches(".fbt-select, .fbt-check")) recalcTotal();
  });

  addBtn.addEventListener("click", () => {
    const items = Array.from(widget.querySelectorAll(".fbt-item"))
      .filter((row) => row.querySelector(".fbt-check").checked)
      .map((row) => {
        const opt = row.querySelector(".fbt-select").selectedOptions[0];
        return { id: +opt.value, quantity: 1 };
      });

    if (!items.length) return;

    fetch("/cart/add.js", {
      method:  "POST",
      headers: { "Content-Type": "application/json" },
      body:    JSON.stringify({ items })
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then(() => {
        /* 1 ▸ let the theme rebuild the drawer’s HTML */
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

        /* 2 ▸ make sure the drawer actually slides open and stays open */
        document.dispatchEvent(new Event('cart:open'));

        /* 3 ▸ OPTIONAL fallback for themes without a drawer */
        if (!hasDrawerDOM) window.location.href = '/cart';
      })
      .catch((err) => {
        console.error("FBT: add-to-cart failed", err);
        alert("Sorry, we couldn’t add those items to the cart.");
      });
  });
}


